<script setup>
import { ref } from 'vue'
import TopBarBasic from '@/components/ui/topbar/TopBarBasic.vue';

import { useUserStore } from '@/stores/user'
import { useRouter } from 'vue-router'
import MdiMenuIcon from 'vue-material-design-icons/Menu.vue'

const userStore = useUserStore()

const navMenuButton = ref(null)

const router = useRouter()

const logoutUser = async () => {
    try {
        await userStore.handleLogout()
        router.push({ name: 'login' })
    } catch (error) {
        // do nothing
    }
}

defineEmits(['togglemenu'])

defineExpose({
    navMenuButton
})

</script>

<template>
    <top-bar-basic>
        <template #beforelogo>
            <!-- menu icon for small screens -->
            <!-- <div class="p-2.5 md:hidden"></div> -->
            <div class="p-2.5 md:hidden" @click="$emit('togglemenu')" id="navMenuButton" ref="navMenuButton">
                <mdi-menu-icon />
            </div>
        </template>
        <template #rightarea>
            <div class="flex flex-row" v-if="userStore.isLoggedIn">
                <div class="m-2 text-xl max-md:hidden">
                    {{ userStore.userData.name }}
                </div>
                <pv-button label="Wyloguj się" @click="logoutUser" />
            </div>
        </template>
    </top-bar-basic>
</template>